import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { history } from '../../../../../redux';
import { getUrl } from '../../../../../services/utils';

/**
 * Handles the generation and redirection of PDF proposals.
 */
const useProposal = ({ loadingProposal, proposalToken, getProposalRequest, campaign }) => {
  const { i18n } = useTranslation();
  const [viewProposal, setViewProposal] = useState(false);

  useEffect(() => {
    if (!loadingProposal && viewProposal && proposalToken && proposalToken.token) {
      let lenguageParse;
      switch (i18n.language) {
        case 'es':
          lenguageParse = 'esLA';
          break;
        case 'es_ar':
          lenguageParse = 'es';
          break;
        default:
          break;
      }
      setViewProposal(false);
      const parameter = `lenguage=${lenguageParse || i18n.language}&token=${proposalToken.token}`;
      window.open(getUrl(window.location, 'proposal.html', parameter));
      history.push(`/proposals`);
    }
  }, [loadingProposal]);

  const getProposal = () => {
    setViewProposal(true);
    getProposalRequest({ campaign_id: campaign.id });
  };

  return { getProposal };
};

export default useProposal;
